"use client"

import { useTr } from "../../lib/use-tr"
import { Reveal } from "../reveal"

import { cn } from "@/lib/utils"

import { PROCESS_T, ProcessHeading, STEPS } from "./process-shared"

export function Process() {
  const tr = useTr(PROCESS_T)
  return (
    <section
      id="how-it-works"
      aria-labelledby="process-heading"
      className="scroll-mt-28 py-16 sm:py-20 md:py-24"
    >
      <Reveal className="sm:container">
        <div id="process-heading">
          <ProcessHeading />
        </div>

        <div className="relative flex flex-col gap-20 sm:gap-24">
          {STEPS.map((step, idx) => {
            const reverse = idx % 2 === 1
            const isLast = idx === STEPS.length - 1
            const Icon = step.icon
            return (
              <div key={step.num} className="relative">
                <div
                  className={cn(
                    "grid items-center gap-8 lg:grid-cols-2 lg:gap-16",
                  )}
                >
                  <div className={cn(reverse && "lg:order-2")}>
                    <div className="text-muted-foreground mb-3 flex items-center gap-3 text-xs font-medium">
                      <span className="bg-primary-cta/10 text-primary-cta inline-flex size-8 items-center justify-center rounded-lg">
                        <Icon className="size-4" aria-hidden />
                      </span>
                      <span className="font-mono tracking-wide uppercase">
                        {tr("step_label")} {step.num}
                      </span>
                    </div>
                    <h3 className="text-foreground font-display tracking-dense text-2xl font-semibold sm:text-3xl">
                      {tr(step.titleKey)}
                    </h3>
                    <p className="text-muted-foreground text-md mt-3 max-w-md leading-relaxed">
                      {tr(step.bodyKey)}
                    </p>
                  </div>
                  <div
                    className={cn(
                      "flex justify-center lg:justify-start",
                      reverse && "lg:order-1 lg:justify-end",
                    )}
                  >
                    <div className="bg-muted/40 ring-border/40 flex w-full max-w-md items-center justify-center rounded-2xl p-6 ring-1 sm:p-8">
                      {step.visual()}
                    </div>
                  </div>
                </div>

                {!isLast ? <DottedArrow reverse={reverse} /> : null}
              </div>
            )
          })}
        </div>
      </Reveal>
    </section>
  )
}

function DottedArrow({ reverse }: { reverse: boolean }) {
  return (
    <svg
      aria-hidden
      viewBox="0 0 200 80"
      preserveAspectRatio="none"
      className={cn(
        "text-primary-cta/50 pointer-events-none absolute -bottom-16 left-1/2 hidden h-16 w-40 -translate-x-1/2 sm:-bottom-20 sm:h-20 lg:block",
      )}
    >
      <path
        d={
          reverse
            ? "M 180 0 C 180 40, 20 40, 20 76"
            : "M 20 0 C 20 40, 180 40, 180 76"
        }
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeDasharray="3 5"
        strokeLinecap="round"
      />
      <path
        d={reverse ? "M 14 70 L 20 78 L 26 70" : "M 174 70 L 180 78 L 186 70"}
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
